export const translations = {
  PT: {
    nav: {
      home: 'Início',
      about: 'Sobre',
      areas: 'Áreas',
      partners: 'Parceiros',
      contact: 'Contacto',
    },
    hero: {
      subtitle: 'Advogada',
      tagline: 'Vasta experiência jurídica ao serviço dos seus interesses.',
      cta: 'Saiba Mais',
    },
    about: {
      sectionLabel: 'Sobre',
      title: 'Comprometida com a Excelência Jurídica',
      bio1: 'Jéssica Costa da Silva é advogada com vasta experiência jurídica, atuando nas mais diversas áreas do direito. O seu compromisso com cada cliente reflete-se na dedicação, rigor e acompanhamento personalizado que oferece em cada caso.',
      bio2: 'Para além da advocacia, realiza também atos notariais, proporcionando um serviço jurídico completo e integrado. A sua abordagem combina um conhecimento técnico aprofundado com uma atenção genuína às necessidades de cada pessoa.',
      bar: 'Membro da Ordem dos Advogados',
    },
    areas: {
      sectionLabel: 'Áreas de Prática',
      title: 'Serviços Jurídicos',
      subtitle: 'Acompanhamento especializado nas mais diversas áreas do direito',
      items: [
        {
          title: 'Direito de Família',
          desc: 'Divórcio, regulação do poder paternal, adoções, alimentos e uniões de facto.',
        },
        {
          title: 'Direito Imobiliário',
          desc: 'Compra e venda de imóveis, contratos de arrendamento e direitos de propriedade.',
        },
        {
          title: 'Direito Laboral',
          desc: 'Contratos de trabalho, rescisões, despedimentos e litígios laborais.',
        },
        {
          title: 'Direito Civil',
          desc: 'Contratos, responsabilidade civil, sucessões e heranças.',
        },
        {
          title: 'Direito Penal',
          desc: 'Defesa e representação em processos criminais e contraordenacionais.',
        },
        {
          title: 'Atos Notariais',
          desc: 'Escrituras, procurações, testamentos, reconhecimentos e autenticações.',
        },
      ],
    },
    partners: {
      sectionLabel: 'Parceiros',
      title: 'Parceiros',
      subtitle: 'Uma rede de confiança ao serviço dos nossos clientes',
      acdDesc: 'Escritório de advocacia com mais de 30 anos de experiência, sediado em Lisboa e nos Açores. Especializado em Direito Penal, Comercial, Civil, Laboral e Administrativo.',
      luisChavesDesc: 'Advogado com sede em Ponta Delgada, São Miguel, Açores. Vasta experiência nas diversas áreas do Direito, com foco no aconselhamento e acompanhamento em todas as fases do processo jurídico.',
      visit: 'Visitar o site',
    },
    contact: {
      sectionLabel: 'Contacto',
      title: 'Entre em Contacto',
      subtitle: 'Estamos disponíveis para si',
      addressLabel: 'Morada',
      address: 'Rua Dr. Albino José da Silva nº 31',
      addressCity: '4830-575 Póvoa de Lanhoso',
      phoneLabel: 'Telefone',
      phone: '919 947 343',
      emailLabel: 'Email',
      email: 'jessica.silva-67425L@adv.oa.pt',
      hoursLabel: 'Horário',
      hours: 'Segunda a Sexta',
      hoursTime: '09:30 — 19:00',
      mapLink: 'Ver no Mapa',
    },
    footer: {
      tagline: 'Advogada',
      rights: 'Todos os direitos reservados.',
      address: 'Rua Dr. Albino José da Silva nº 31, 4830-575 Póvoa de Lanhoso',
    },
  },
  EN: {
    nav: {
      home: 'Home',
      about: 'About',
      areas: 'Areas',
      partners: 'Partners',
      contact: 'Contact',
    },
    hero: {
      subtitle: 'Lawyer',
      tagline: 'Extensive legal expertise in service of your interests.',
      cta: 'Learn More',
    },
    about: {
      sectionLabel: 'About',
      title: 'Committed to Legal Excellence',
      bio1: 'Jéssica Costa da Silva is a lawyer with extensive legal experience, practising across a wide range of legal disciplines. Her commitment to each client is reflected in the dedication, rigour and personalised support she provides in every case.',
      bio2: 'In addition to legal practice, she also offers notarial services, providing a complete and integrated legal service. Her approach combines deep technical expertise with genuine attention to each person\'s individual needs.',
      bar: 'Member of the Portuguese Bar Association',
    },
    areas: {
      sectionLabel: 'Practice Areas',
      title: 'Legal Services',
      subtitle: 'Specialised support across the most diverse areas of law',
      items: [
        {
          title: 'Family Law',
          desc: 'Divorce, child custody, adoptions, maintenance and cohabitation.',
        },
        {
          title: 'Real Estate Law',
          desc: 'Property purchase and sale, rental agreements and property rights.',
        },
        {
          title: 'Employment Law',
          desc: 'Employment contracts, terminations, dismissals and labour disputes.',
        },
        {
          title: 'Civil Law',
          desc: 'Contracts, civil liability, successions and inheritances.',
        },
        {
          title: 'Criminal Law',
          desc: 'Defence and representation in criminal and regulatory proceedings.',
        },
        {
          title: 'Notarial Acts',
          desc: 'Deeds, powers of attorney, wills, authentications and certifications.',
        },
      ],
    },
    partners: {
      sectionLabel: 'Partners',
      title: 'Partners',
      subtitle: 'A trusted network in service of our clients',
      acdDesc: 'A law firm with over 30 years of experience, based in Lisbon and the Azores. Specialising in Criminal, Commercial, Civil, Employment and Administrative Law.',
      luisChavesDesc: 'Lawyer based in Ponta Delgada, São Miguel, Azores. Extensive experience across various areas of law, with a focus on advisory services and support throughout all stages of the legal process.',
      visit: 'Visit website',
    },
    contact: {
      sectionLabel: 'Contact',
      title: 'Get In Touch',
      subtitle: 'We are available for you',
      addressLabel: 'Address',
      address: 'Rua Dr. Albino José da Silva nº 31',
      addressCity: '4830-575 Póvoa de Lanhoso',
      phoneLabel: 'Phone',
      phone: '919 947 343',
      emailLabel: 'Email',
      email: 'jessica.silva-67425L@adv.oa.pt',
      hoursLabel: 'Hours',
      hours: 'Monday to Friday',
      hoursTime: '09:30 — 19:00',
      mapLink: 'View on Map',
    },
    footer: {
      tagline: 'Lawyer',
      rights: 'All rights reserved.',
      address: 'Rua Dr. Albino José da Silva nº 31, 4830-575 Póvoa de Lanhoso',
    },
  },
};
